export class GetAllSectorsAction {
  static readonly type = '[Demans] Get All';
  constructor() {}
}
